import { z } from 'zod';

/**
 * Canvas Domain Value Objects
 * Domain-specific value objects for canvas operations
 */

// === Canvas ID Value Objects ===

export const CanvasIdSchema = z.string().cuid({
  message: "Invalid Canvas ID format. Must be a valid CUID."
});

export const NodeIdSchema = z.string().min(1, {
  message: "Node ID cannot be empty"
});

// === Canvas String Value Objects ===

export const CanvasTitleSchema = z.string()
  .min(1, { message: "Session title cannot be empty" })
  .max(255, { message: "Session title must be less than 255 characters" })
  ;

export const CanvasDescriptionSchema = z.string()
  .max(1000, { message: "Canvas description must be less than 1000 characters" })
  .nullable()
  ;

export const ThumbnailUrlSchema = z.string()
  .url({ message: "Invalid thumbnail URL format" })
  .nullable()
  ;

export const CanvasSortFieldSchema = z.enum(['createdAt', 'updatedAt', 'title'], {
  error: "Invalid canvas sort field. Must be one of: createdAt, updatedAt, title"
});

// Export TypeScript types
export type CanvasId = z.infer<typeof CanvasIdSchema>;
export type NodeId = z.infer<typeof NodeIdSchema>;
export type CanvasTitle = z.infer<typeof CanvasTitleSchema>;
export type CanvasDescription = z.infer<typeof CanvasDescriptionSchema>;
export type ThumbnailUrl = z.infer<typeof ThumbnailUrlSchema>;
export type CanvasSortField = z.infer<typeof CanvasSortFieldSchema>;